import { create } from 'zustand';
import { SchoolOutput } from '@/api/gql/graphql';

type EstablishmentStore = {
  isOpenEstablishmentDeletionModal: boolean;
  isOpenEstablishmentSendMailModal: boolean;
  openEstablishmentDeletionModal: () => void;
  closeEstablishmentDeletionModal: () => void;
  openEstablishmentSendMailModal: () => void;
  closeEstablishmentSendMailModal: () => void;

  isOpenEstablishmentDetailModal: boolean;
  openEstablishmentDetailModal: () => void;
  closeEstablishmentDetailModal: () => void;

  openEstablishmentModal: boolean;
  setOpenEstablishmentModal: (state: boolean) => void;

  // Nouveau : Gestion du modal d'édition
  isOpenEstablishmentEditModal: boolean;
  editingEstablishment: SchoolOutput | null;
  openEstablishmentEditModal: (establishment: SchoolOutput) => void;
  closeEstablishmentEditModal: () => void;

  // Nouveau : Gestion de l'email pour le renvoi de mail
  selectedEstablishmentEmail: string;
  setSelectedEstablishmentEmail: (email: string) => void;

  // Gestion du mode désactivation/réactivation
  deactivationMode: 'deactivate' | 'reactivate';
  setDeactivationMode: (mode: 'deactivate' | 'reactivate') => void;

  // ID de l'établissement sélectionné pour les actions
  selectedEstablishmentId: string;
  setSelectedEstablishmentId: (id: string) => void;
};

export const useEstablishmentStore = create<EstablishmentStore>((set) => ({
  isOpenEstablishmentDeletionModal: false,
  isOpenEstablishmentSendMailModal: false,
  openEstablishmentDeletionModal: () =>
    set({ isOpenEstablishmentDeletionModal: true }),
  closeEstablishmentDeletionModal: () =>
    set({ isOpenEstablishmentDeletionModal: false }),
  openEstablishmentSendMailModal: () =>
    set({ isOpenEstablishmentSendMailModal: true }),
  closeEstablishmentSendMailModal: () =>
    set({ isOpenEstablishmentSendMailModal: false }),

  isOpenEstablishmentDetailModal: false,
  openEstablishmentDetailModal: () =>
    set({ isOpenEstablishmentDetailModal: true }),
  closeEstablishmentDetailModal: () =>
    set({ isOpenEstablishmentDetailModal: false }),

  openEstablishmentModal: false,
  setOpenEstablishmentModal: (state) => set({ openEstablishmentModal: state }),

  // Nouveau : Implémentation du modal d'édition
  isOpenEstablishmentEditModal: false,
  editingEstablishment: null,
  openEstablishmentEditModal: (establishment) =>
    set({
      isOpenEstablishmentEditModal: true,
      editingEstablishment: establishment,
    }),
  closeEstablishmentEditModal: () =>
    set({
      isOpenEstablishmentEditModal: false,
      editingEstablishment: null,
    }),

  // Nouveau : Implémentation de l'email pour le renvoi de mail
  selectedEstablishmentEmail: '',
  setSelectedEstablishmentEmail: (email) =>
    set({ selectedEstablishmentEmail: email }),

  // Implémentation du mode désactivation/réactivation
  deactivationMode: 'deactivate',
  setDeactivationMode: (mode) => set({ deactivationMode: mode }),

  // Implémentation de l'ID sélectionné
  selectedEstablishmentId: '',
  setSelectedEstablishmentId: (id) => set({ selectedEstablishmentId: id }),
}));
